import branch from 'branch-sdk';
import get from 'lodash/get';

import env from '../env';

export const branchInit = () => {
  branch.init(get(env, 'BRANCH_KEY', null));
};
